import ReactStrapTable from 'components/reactStrapTable';
import React, { useState } from 'react'
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import { cloneDeep } from 'lodash';
import useAxios from 'hooks/useAxios';

const DrugCatlogTable = (props) => {
    const {
        togglePriceHistory,
        onPageChange,
        totalitem,
        data,
        orgId,
        refetch,
        filters,
        onSearchColumnFilters = () => '',
        collapseSider,
        toggleSider,
        resetFilterFlag,
        SetResetFilterFlag,
        tabKey
    } = props;
    const API = useAxios();
   
     const [loading, setLoading] = useState(false);
     const [columnFilters, setColumnFilters] = useState([]);


  const handelPrice = async (rowData,accunttype) => {
        await togglePriceHistory(rowData,accunttype);
  }
    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {/* {renderWacPrice()} */}
                {/* {renderViewButton(rowData)}
                {renderAttachementsButton(rowData)} */}
            </div>
        );
    };
       
    let mainCol = [
      {
        dataField: 'edit',
        text: 'Options',
        cellRenderer: (rowData) => cellRenderEdit(rowData),
        width: 100,
        show: true,
        disabled: true,
        action: true,
    },
      {
        dataField: "itemNumber",
        text: "Item #",
        sort: true,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row.itemNumber),
      },
      {
        dataField: "ndc",
        text: "NDC",
        sort: true,
        width: 150,
        show: true,
        inputType: "text",
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row.ndc),
      },
      {
        dataField: "drugName",
        text: "Drug Name",
        sort: true,
        width: 240,
        show: true,
        inputType: "text",
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row.drugName),
      },
      {
        dataField: "drugManufacturerName",
        text: "Manufacturer",
        sort: false,
        width: 240,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.drugManufacturerName),
      },
      {
        dataField: "therapeuticClass",
        text: "Therapeutic Class",
        sort: false,
        width: 280,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.therapeuticClass),
      },
      {
        dataField: "brandGenericFlag",
        text: "Brand or Generic",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.brandGenericFlag),
      },
      {
        dataField: "packageSize",
        text: "Package Size",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.packageSize),
      },
      {
        dataField: "drugForm",
        text: "Drug Form",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.drugForm),
      },
      {
        dataField: "packageWACPrice",
        text: "WAC Price",
        sort: false,
        width: 130,
        show: true,
        inputType: "number",
        hideColFilter: true,
        cellRenderer: (row) => row.packageWACPrice == null ? '-' : cellRenderLink(row, 'WAC'),
      },
      {
        dataField: "packageGPOPrice",
        text: "GPO Price ",
        sort: false,
        width: 130,
        show: true,
        inputType: "number",
        hideColFilter: true,
        cellRenderer: (row) => row.packageGPOPrice == null ? '-' : cellRenderLink(row, 'GPO'),
      },
      {
        dataField: "package340BPrice",
        text: "340B Price ",
        sort: false,
        width: 130,
        show: true,
        inputType: "number",
        hideColFilter: true,
        cellRenderer: (row) => row.package340BPrice == null ? '-' : cellRenderLink(row, '340B'),
      },
      {
        dataField: "reason",
        text: "Reason",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.reason),
      },
      {
        dataField: "modifiedBy", 
        text: "Modified By",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.modifiedBy),
      },
      {
        dataField: "modifiedDate",
        text: "Modified Date",
        sort: false,
        width: 120,
        show: true,
        inputType: "date",
        hideColFilter: true,
        cellRenderer: (row) => dateFormate(row.modifiedDate),
      }
    ];
    const cellRenderLink = (rowData, accounttype) => {
      if (!rowData.package340BPrice) return "-";
          return (
            <span
              className="text-decoration-underline d-inline-block cursor-pointer"
              onClick={() => handelPrice(rowData,accounttype)}
            >
              {currencyFormat(accounttype == '340B'? rowData.package340BPrice : accounttype == 'GPO' ? rowData.packageGPOPrice : rowData.packageWACPrice)}
            </span>
          );
      };
    
      const onHandleSort = (filter, hasColFilter) => {
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };
      const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {

        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            onPageChange(filter);
        }
    };
    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {

      if (hasColFilter) {
          const colFilterOn = { ...filter, filters: colChangedFilter };
          return onPageChange(colFilterOn, true);
      }
      onPageChange(filter);
  };
  const handleFilterCancel = () => {
    debugger;
      setColumnFilters([])
    refetch();
};
const handleSearchColumnFilters = (colFilter) => {
debugger;
  if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      setColumnFilters(colFilter);
  }
};
 const handleExport = async () => {
      debugger;
      setLoading(true);
      const filterObj = cloneDeep(filters);
      // filterObj.AccumulatorIDs = filterObj.accumulationIds;
      // delete filterObj.accumulationIds;
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
  
      const { access_token } =
        JSON.parse(localStorage.getItem('pharmaforce')) || {};
  
        var additionalCriteria = {};
        additionalCriteria.IsSelectedColumn = false;
        additionalCriteria.OrgId = orgId.organizationID;
         // additionalCriteria.ContractId = 0;
      // additionalCriteria.POId = 0;
      // additionalCriteria.OpaId = 0;
      // additionalCriteria.CEId = 0;
      // additionalCriteria.ManufactureId = 0;
  
      var payload = {};
      payload.tenantID = orgId.tenantID
      payload.gridCode = "drugCatalog";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
      setLoading(false);
    //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    //  onExport(action, initialFilters);
    };
  return (
    
    <div>
       <h5 className="f-16 text-primary font-weight-700">
        Drug Count ({totalitem})
      </h5>
      <hr/>
              <div
            // className='table-card scroll-table position-relative border-0 rounded pt-0'
            // fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
            className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          data.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
        >
            <ReactStrapTable
                id='drug-catlog-table'
                height={550}
                fixedColumn
                width={1200}
                data={data}
                columns={mainCol}
                hasPagination={data.length>0 ? true :false}
                onExport={handleExport}
                filters={filters}
                totalRecords={totalitem}
                pageSize={filters.pageSize}                 
                currentPage={filters.currentPage}
                onPageChange={onHandlePageChange}
                onPageSizeChange={onPageSizeChange}
                onFilterCancel={handleFilterCancel}
                onSearchColumnFilters={handleSearchColumnFilters}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                showtoggle={true}
               handleSort={onHandleSort}
               keytab={tabKey}
            />
        </div>
    </div>
  )
}
export default DrugCatlogTable;
